(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise((resolve, reject) => {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      ta.style.top = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      ta.setSelectionRange(0, ta.value.length);
      try {
        const ok = document.execCommand("copy");
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error("execCommand copy failed"));
      } catch (e) {
        document.body.removeChild(ta);
        reject(e);
      }
    });
  }

  function ensureCheck(btn) {
    let check = btn.querySelector(".tb-coupon-check");
    if (check) return check;

    check = document.createElement("span");
    check.className = "tb-coupon-check";
    check.setAttribute("aria-hidden", "true");
    check.textContent = "✓";
    btn.appendChild(check);

    return check;
  }

  function flashCheck(btn, ms = 1200) {
    ensureCheck(btn);
    btn.classList.add("tb-copied");

    window.clearTimeout(btn.__tbCopiedTimer);
    btn.__tbCopiedTimer = window.setTimeout(() => {
      btn.classList.remove("tb-copied");
    }, ms);
  }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".tb-card-coupons-static-button");
    if (!btn) return;

    const codeEl = btn.querySelector(".tb-card-coupons-static-code");
    const code = codeEl ? codeEl.textContent.trim() : "";
    if (!code) return;

    try {
      await copyText(code);
      flashCheck(btn);
    } catch (err) {
      // si quieres, aquí podrías hacer un shake o algo visual de error
      // console.error(err);
    }
  });
})();
